/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */

import map from 'lodash/map';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { API_HOSTNAME, FILTER_SEARCH } from '../../../modules/app/Api';
import { requestSaga } from '../../../sagas/requestSaga';
import { sendTableSearchError, sendTableSearchSuccessful } from '../actions/tableActions';
import { makeSelectorTableCurrentName, makeSelectorTableFilterSearchValue } from '../selectors/tableSelectors';
import { MapTableNameToApiPath } from '../types/tableMapTypes';
import { ISendTableSearchPayload, TableNameType } from '../types/tableTypes';

export function* sendTableSearchSaga({ payload }: { payload: ISendTableSearchPayload; type: string }): SagaIterator {

    const tableName: TableNameType = yield select(makeSelectorTableCurrentName());
    const tableSearchValue = yield select(makeSelectorTableFilterSearchValue());
    const URL =
        MapTableNameToApiPath[tableName]
        + FILTER_SEARCH
        + `/${payload.field}`
        + `?term=${encodeURIComponent(tableSearchValue)}`;

    try {
        const response = yield call(requestSaga, API_HOSTNAME + URL, 'GET', null, {
            abortControllerId: MapTableNameToApiPath[tableName] + FILTER_SEARCH,
        });
        const result = map(response.suggestEntities, item => item.text);
        yield put(sendTableSearchSuccessful({ tableName, result }));
    } catch (error: any) {
        if (error.name !== 'AbortError') {
            yield put(sendTableSearchError({ tableName, error }));
        }
    }
}
